module.exports = __webpack_public_path__ + "static/cloud-bd58125c90a159f73c34c3eb9698fef1.png";